import { combineReducers } from "@reduxjs/toolkit";
import userSlice from "./features/user/userSlice";
// import user from "./features/user/userSlice";
import billerSlice from "./features/billers/billerSlice";
import billerDetailSlice from "./features/billerDetails/billerDetailSlice";
import categoryOptionsSlice from "./features/categoryOptions/categoryOptionSlice";
import refIdsSlice from "./features/categoryOptions/refIdsSlice";
import billFetchSlice from "./bbps/billFetch/billFetchSlice";
import billerPlansSlice from "./bbps/billerPlans/billerPlanSlice";
import billValidationSlice from "./bbps/billValidation/billValidationSlice";
import billPaymentSlice from "./bbps/billPayment/billPaymentSlice";
import razorpaySlice from "./paymentGateway/razorpay/razorpaySlice";
import billerRegionsSlice from "./bbps/billerRegions/billerRegionsSlice";
import walletSlice from "./wallet/walletSlice";
import transactionsSlice from "./userTransaction/userTransactionSlice";
import { bbpsComplaintReducer } from "./bbps/Complaint/bbpsComplaintSlice";

const rootReducer = combineReducers({
  user: userSlice,
  wallet: walletSlice,
  billers: billerSlice,
  billerDetails: billerDetailSlice,
  categoryOptions: categoryOptionsSlice,
  refIds: refIdsSlice,
  billFetch: billFetchSlice,
  billerPlans: billerPlansSlice,
  billValidation: billValidationSlice,
  billPayment: billPaymentSlice,
  razorpaypg: razorpaySlice,
  billerRegions: billerRegionsSlice,
  transactions: transactionsSlice,
  bbpsComplaint: bbpsComplaintReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;

// export type RootState = ReturnType<typeof rootReducer>;
